module.exports = __webpack_public_path__ + "static/media/Icon-awesome-pen-fancy.2fb84e5d.svg";